import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Loader from 'components/Loader/index';
import GridWrapper from '../../../custom-hooks/GridWrapper';
import { PartyType } from './PartyType';


const init = {
    key: 'search',
    method: 'post',
    page: 1,
    start: 0,
    limit: 7,
    type: "customer"
};

const CustomersGrid = props => {
    const { selectItem, gridSearch } = props;
    const [loadingState, setLoadingState] = useState(true);

    const getParams = () => ({
        selectItem,
        rowDnD: false,
        fields: {
            partyType: {
                component: PartyType
            }
        }
    });

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    return (
        <div className='content-wrapper'>
            {loadingState && <Loader />}
            <GridWrapper
                tuner={() => (init)}
                initUpdate={false}
                gridParams={getParams()}
                gridSearch={gridSearch}
                onStart={onStart}
                onFinish={onFinish}
            />
        </div>
    );
};

export default withRouter(CustomersGrid);
